import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import Blink from '@components/Blink'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

interface FooterProps {
  onClose: () => void
  onClickNext: () => void
  isLastStep?: boolean
}

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8, spacing24 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing8};
    align-items: center;
    margin-bottom: ${spacing24};
  `}
`

const StyledPrimaryButton = styled(PrimaryCTAButton)`
  min-width: 162px;
`

const StyledText = styled.span`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodyCopyCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${xxsmallBodyCopyCSS};
    color: ${textDefault};
    text-align: center;
    max-width: 250px;
  `}
`

const StyledLink = styled(Blink)`
  ${({
    theme: {
      colors: { textDefault },
    },
  }) => css`
    color: ${textDefault};
  `}
`
const Footer: FunctionComponent<FooterProps> = ({
  onClickNext,
  onClose,
  isLastStep,
}) => {
  return (
    <StyledWrapper>
      <StyledPrimaryButton
        size={'large'}
        onClick={isLastStep ? onClose : onClickNext}>
        {translate(
          isLastStep
            ? 'blickPlusOnboardingModal.finishButton'
            : 'blickPlusOnboardingModal.nextButton'
        )}
      </StyledPrimaryButton>
      {isLastStep && (
        <StyledText>
          {translate('blickPlusOnboardingModal.feedback')}
          <StyledLink href="/test">
            {translate('blickPlusOnboardingModal.feedbackLink')}
          </StyledLink>
        </StyledText>
      )}
    </StyledWrapper>
  )
}

export default Footer
